import "./App.css";
import Navbar from "./layouts/Navbar";
import TopBar from "./layouts/TopBar";
import Footer from "./layouts/Footer";
import Home from "./pages/Home/index";
import About from "./pages/About/index";
import Services from "./pages/Services/index";
import Contact from "./pages/Contact/index";
import Blog from "./pages/Blog/index";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Library from "./pages/Library";
// import Solution from "./pages/SolutionDetail/index";
import OurTeam from "./pages/OurTeam/index";
import Cases from "./pages/OurCases/index";
import Research from "./pages/Research&Development/index";
import Certificates from "./pages/DistributorsCertificates/index";
import Career from "./pages/Career/index";
import ProductsFromVendors from "./pages/ProductsFromVendors";
import SolutionDetail from "./components/solution-detail/SolutionDetail";
import SolutionDropdown from "./components/solutiondropdown/SolutionDropdown";
import SafetyPage from "./pages/SafetyManagement/index";
import { SolutionDropdownProvider } from "./components/hooks/SolutionDropdownContext";
import NotFound from "./components/not_found/NotFound";
import BlogDetail from "./components/blog/BlogDetail";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";
import { useEffect } from 'react';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import BrowseLibrary from "./pages/BrowseLibrary";
import { LibraryDetailPage } from "./pages/LibraryDetail.jsx";

function App() {
  // Apply the language-specific class to the body
  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'en';
    document.body.classList.toggle('lang-ru', lang === 'ru'); // Add lang-ru class if Russian
  }, [i18n.language]);
  return (
    <div>
      <I18nextProvider i18n={i18n}>
        <SolutionDropdownProvider>
          <BrowserRouter>
            <TopBar />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about_us" element={<About />} />
              <Route path="/blogs" element={<Blog />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact_us" element={<Contact />} />
              {/* <Route path="/library" element={<Library />} /> */}
              {/* <Route path="/solution-detail" element={<Solution />} /> */}
              <Route path="/" element={<SolutionDropdown />} />
              <Route path="/solution/:id" element={<SolutionDetail />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/library" element={<BrowseLibrary />} />
              <Route path="/library/library-detail/:slug" element={<LibraryDetailPage />} />
              {/* <Route path="/library/browse-library/library-detail" element={<LibraryDetailPage />} /> */}
              <Route path="/blog/:slug" element={<BlogDetail />} />

              <Route path="/our_team" element={<OurTeam />} />
              <Route path="/our_cases" element={<Cases />} />
              <Route path="/r&d" element={<Research />} />
              <Route path="/distributor_certificates" element={<Certificates />} />
              <Route path="/career" element={<Career />} />
              <Route
                path="/products_from_vendors"
                element={<ProductsFromVendors />}
              />
              <Route path="/safety_management" element={<SafetyPage />} />
              <Route path="*" element={<NotFound />} />

            </Routes>
            <Footer />
          </BrowserRouter>
        </SolutionDropdownProvider>
      </I18nextProvider>
      <ToastContainer />
    </div>
  );
}
export default App;
